(function(EF, undefined) {

  var Response = Backbone.Model.extend({

    validate: function(attrs, options) {
      if(!attrs.answer_id) return 'Must include an answer_id';
    },
    toJSON: function() {
      return { response: _.clone( this.attributes ) };
    }
  });

  _.extend(EF.Models, {
    Response: Response
  });

})(EF);
